import React, {Component} from 'react';
import AdminHomeTableRow from './admin-home-table-row-data';
class AdminHomeTableUsers extends Component{

    

    render(){

        return(
           <div className="tab-pane fade show active" id="allUsers" role="tabpanel">
                 <div className="text-center">
                    <a className="admin-add-btn red-btn" href="#addnewuserModal" data-toggle="modal">اضافة مستخدم جديد</a>
                </div>
               <div className="users-table-admin">
               
                <table className="table users-table-admin table-responsive-md">
                        <thead>
                            <tr>
                                <th>رقم المستخدم</th>
                                <th>اسم المستخدم</th>
                                <th>اسم الشركة </th>
                                <th>البريد الالكتروني</th>
                                <th>عدد الدراسات</th>
                                <th>الحالة</th>
                                <th>المهام</th>
                            </tr>
                        </thead>
                        <tbody>
                                <AdminHomeTableRow userID={"1"} userName={"أحمد محمد البنا"} companyName={"CRETE Agency"} userMail={"bana@creteagency.com"}  studiesQuantity={"100"} userStatus={"نشط"}/>
                                <AdminHomeTableRow userID={"2"} userName={"أحمد محمد البنا"} companyName={"CRETE Agency"} userMail={"bana@creteagency.com"}  studiesQuantity={"4"} userStatus={"غير نشط"}/>
                                <AdminHomeTableRow userID={"3"} userName={"أحمد محمد البنا"} companyName={"CRETE Agency"} userMail={"bana@creteagency.com"}  studiesQuantity={"50"} userStatus={"نشط"}/>
                                <AdminHomeTableRow userID={"4"} userName={"أحمد محمد البنا"} companyName={"CRETE Agency"} userMail={"bana@creteagency.com"}  studiesQuantity={"10"} userStatus={"نشط"}/>
                        </tbody>
                    </table>
                </div>
            </div>
                        
            
        );
       
    }

};
export default AdminHomeTableUsers;


